import { useSelector } from 'react-redux';

import { onboardingHints } from '../../constants';
import { selectUser } from '../../reducers/user.selectors';
import { isAIToolsPagePath } from '../../utils/isAIToolsPagePath';
import { shouldDisplayHintsAndOnboardingDialogs } from '../../utils/shouldDisplayHintsAndOnboardingDialogs';
import useOnboardingDialog from '../../utils/useOnboardingDialog';
import useRouter from '../../utils/useRouter';

// Shared with the school-admin hint, which waits while this dialog is due.
const useShouldShowAiOnlyWelcomeDialog = (): boolean => {
	const user = useSelector(selectUser);
	const { isShown } = useOnboardingDialog(onboardingHints.aiOnlyWelcomeDialog);
	const { match } = useRouter();
	const isAllowedPage = isAIToolsPagePath(match.location.pathname);

	return (
		!!user?.isAiOnlyUser && shouldDisplayHintsAndOnboardingDialogs() && isAllowedPage && !isShown
	);
};

export default useShouldShowAiOnlyWelcomeDialog;
